
export const HEADER_CHANGED_STATE = 'HEADER_CHANGED_STATE';
